import type { TLAsset } from "@tldraw/tlschema";
import { MODEL_FORMATS, type ModelFormat } from "../shared/model-files";

export type ModelAssetInfo = {
  format: ModelFormat;
  name: string;
  source: string;
};

export function modelAssetInfo(asset?: TLAsset | null): ModelAssetInfo | null {
  if (!asset || asset.type !== "image") return null;
  const format = asset.meta.modelFormat;
  const source = asset.meta.modelSource || asset.meta.documentSource;
  const name =
    asset.meta.modelName || asset.meta.documentName || asset.props.name;
  if (
    typeof format !== "string" ||
    !MODEL_FORMATS.includes(format as ModelFormat) ||
    typeof source !== "string" ||
    !source ||
    typeof name !== "string" ||
    !name
  )
    return null;
  return { format: format as ModelFormat, source, name };
}
